import {
  LIBELLE_VOIR_COMME,
  NOM_SEQUENCE_MATHS,
  VOIR_COMME,
  etiquetteSequences,
  etiquetteSequencesAccessible,
  type VoirComme,
} from '@silex/shared';

import { choisirVoirComme, useVoirComme } from '../lib/voir-comme';

/**
 * L'ÉTIQUETTE DE SÉQUENCE (F-84) — « SN », « CST · TS » sur une notion que le
 * programme réserve à une partie des séquences de son chapitre. Le même mot et
 * le même ordre (CST, TS, SN) que sur le chapitre et que dans l'application de
 * l'élève ; le nom entier pour un lecteur d'écran et au survol.
 */
export function EtiquetteSequence({ sequences }: { sequences: readonly string[] | undefined }) {
  const texte = etiquetteSequences(sequences ?? []);
  if (texte === '') return null;
  const entier = etiquetteSequencesAccessible(sequences ?? []);
  return (
    <span
      className="badge badge--en-cours"
      title={entier}
      aria-label={entier}
      data-testid="etiquette-sequence"
    >
      {texte}
    </span>
  );
}

/**
 * « VOIR COMME : TOUTES / CST / TS / SN » — la console relit le programme, ou
 * le manuel d'un élève, comme un élève de cette séquence. Le choix se retient
 * le temps de la session et n'écrit rien ; `surChangement` relit l'écran.
 */
export function SelecteurVoirComme({ surChangement }: { surChangement: () => void }) {
  const choix = useVoirComme();
  return (
    <label className="row" data-testid="voir-comme">
      <span className="cell-sub">Voir comme</span>
      <select
        className="control"
        value={choix}
        onChange={(e) => {
          choisirVoirComme(e.target.value as VoirComme);
          surChangement();
        }}
        aria-label="Voir comme un élève de la séquence"
      >
        {VOIR_COMME.map((v) => (
          <option key={v} value={v}>
            {v === 'toutes'
              ? 'Toutes les séquences'
              : `${LIBELLE_VOIR_COMME[v]} — ${NOM_SEQUENCE_MATHS[v]}`}
          </option>
        ))}
      </select>
    </label>
  );
}
